let focusVisible

if (typeof document !== 'undefined') {
  focusVisible = require('focus-visible')
}

export default focusVisible
